export const FETCH_DRINKS = "FETCH_DRINKS";
export const FETCH_DRINK = "FETCH_DRINK";
export const SET_DRINKS_FILTER = "SET_DRINKS_FILTER";
